import React, {
    memo,
    HTMLProps,
    MutableRefObject,
    useRef,
    useEffect,
    useState,
} from "react";
import { Element } from "../base";
import { Logger, VideoUtils } from "src/utils";

interface IProps extends HTMLProps<HTMLImageElement> {
    className?: string;
    src: string;
    alt?: string;
    title?: string;
    size?: number;
    rounded?: boolean;
}

export function NativeVideo({ src, size = 48, className, ...rest }: IProps) {
    const videoRef: MutableRefObject<any> = useRef(null);
    const onError = () => {
        Logger.errorWithType("webm", 0, "Error load Video fail|src:", { src });
    };
    const [supportWebm, setSupportWebm] = useState<boolean>(false);

    const source = supportWebm ? src + ".webm" : src + ".mp4";
    const type = supportWebm ? "video/webm" : "video/mp4";

    useEffect(() => {
        setSupportWebm(VideoUtils.isSupportWebm());
    }, []);

    useEffect(() => {
        if (videoRef && videoRef.current) {
            videoRef.current.load();
        }
    }, [source]);

    return (
        <Element
            {...rest}
            renderAs="video"
            domRef={videoRef}
            playsInline
            muted
            loop
            autoPlay
        >
            <source onError={onError} src={source} type={type} />
        </Element>
    );
}

export default memo(NativeVideo);
